import * as React from 'react';
// the context module, NOT the provider: this hook is what `src/ui` imports, and the provider would drag
// auth / api / layout into the design system's module graph
import { I18nContext } from './i18n-context';

export const useTranslations = () => React.useContext(I18nContext);
